import React, { useEffect, useContext } from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography,
} from "@mui/material"
import CloseOutlined from "@mui/icons-material/CloseOutlined"
import { useParams } from "react-router-dom"
import Budget2023Context from "context/budget2023/Budget2023Context"
import CloseBud from "assets/images/budgeting/CloseBud.png"
import RecalculatingGif from "assets/images/recalculating.gif"

export default function ModalCargandoRecalc({
  open,
  setOpen,
  projectIdProp,
  onCloseFinished,
}) {
  const { loadingRecalc, recalcBudget } = useContext(Budget2023Context)
  const { projectId: urlProjectId } = useParams()
  const effectiveProjectId = projectIdProp || urlProjectId

  useEffect(() => {
    if (open && effectiveProjectId) {
      recalcBudget(effectiveProjectId)
    }
  }, [open, effectiveProjectId])

  const handleClose = () => {
    if (!loadingRecalc) {
      if (typeof onCloseFinished === "function") {
        onCloseFinished()
      }
    }
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={() => {}} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ p: 2 }}>
        {!loadingRecalc && (
          <IconButton
            aria-label={i18n.t("close")}
            onClick={handleClose}
            size="large"
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseOutlined />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          py: 4,
          height: 290,
        }}
      >
        {loadingRecalc ? (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1,
              }}
            >
              <img
                src={RecalculatingGif}
                alt={i18n.t("recalculating")}
                style={{ width: 128, height: "auto" }}
              />
            </Box>
            <Typography variant="h6">
              {i18n.t("Estamos recalculando tu presupuesto...")}
            </Typography>
            <Typography variant="body2">
              {i18n.t("Esta acción puede tardar unos segundos")}
            </Typography>
            <Typography variant="body2">
              {i18n.t("Por favor no cierres esta pestaña")}
            </Typography>
          </>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 2,
              }}
            >
              <img
                src={CloseBud}
                alt="ok"
                style={{ width: 128, height: 128 }}
              />
            </Box>
            <Box sx={{ maxWidth: 400, lineHeight: 1.2 }}>
              <Typography variant="h6" align="center" sx={{ mt: 2 }}>
                {i18n.t("El presupuesto se ha recalculado correctamente")}
              </Typography>
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 2,
          height: 70,
          display: "flex",
          justifyContent: "center",
          alignItems: "start",
        }}
      >
        {!loadingRecalc && (
          <Button
            variant="contained"
            color="branded"
            size="large"
            onClick={handleClose}
          >
            {i18n.t("Volver")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

ModalCargandoRecalc.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  projectIdProp: PropTypes.string,
  onCloseFinished: PropTypes.func,
}
